var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricIconTotalQueActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#EAE7FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F8F7FE",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.92431 23.2226C10.1445 25.2807 11.7998 26.936 13.8569 27.1653C15.3848 27.3356 16.9536 27.4818 18.5531 27.4818C20.1525 27.4818 21.7213 27.3356 23.2492 27.1653C25.3064 26.936 26.9616 25.2807 27.1818 23.2226C27.3444 21.7033 27.4816 20.1435 27.4816 18.5533C27.4816 16.963 27.3444 15.4032 27.1818 13.8839C26.9616 11.8259 25.3064 10.1706 23.2492 9.94128C21.7213 9.77097 20.1525 9.62469 18.5531 9.62469C16.9536 9.62469 15.3848 9.77097 13.8569 9.94128C11.7998 10.1706 10.1445 11.8259 9.92431 13.8839C9.76176 15.4032 9.6245 16.963 9.6245 18.5533C9.6245 20.1435 9.76176 21.7033 9.92431 23.2226Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92431 23.2226C10.1445 25.2807 11.7998 26.936 13.8569 27.1653C15.3848 27.3356 16.9536 27.4818 18.5531 27.4818C20.1525 27.4818 21.7213 27.3356 23.2492 27.1653C25.3064 26.936 26.9616 25.2807 27.1818 23.2226C27.3444 21.7033 27.4816 20.1435 27.4816 18.5533C27.4816 16.963 27.3444 15.4032 27.1818 13.8839C26.9616 11.8259 25.3064 10.1706 23.2492 9.94128C21.7213 9.77097 20.1525 9.62469 18.5531 9.62469C16.9536 9.62469 15.3848 9.77097 13.8569 9.94128C11.7998 10.1706 10.1445 11.8259 9.92431 13.8839C9.76176 15.4032 9.6245 16.963 9.6245 18.5533C9.6245 20.1435 9.76176 21.7033 9.92431 23.2226Z",
    stroke: "#7F6CE5",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9102 14.4015H13.5126",
    stroke: "#7F6CE5",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7316 18.5533H13.5126",
    stroke: "#7F6CE5",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9102 22.8835H13.5126",
    stroke: "#7F6CE5",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconTotalQueActivity);
export default __webpack_public_path__ + "static/media/MetricIconTotalQue-activity.59a5cf9077033b53320658500ce64377.svg";
export { ForwardRef as ReactComponent };